import { connect } from 'react-redux';
import AppliedFilters from 'common/filter/containers/applied';

const mapStateToProps = (state) => {
  return {
    fieldLabels: {
      entry_eliminated: "eliminated",
      entry_withdrawn: "withdrawn",
      entry_runnerup: "awarded",
      created_at: "submitted",
      entry_author_username: "author"
    }
  };
}

export default connect(mapStateToProps)(AppliedFilters);



// WEBPACK FOOTER //
// ./entries/containers/applied_filters.js